import * as types from './types';
import { BakedBreadTagEntity } from 'src/firebase/db/BakedBreadTags';
import { APISuccessfulResponse, APIFailedResponse } from 'src/firebase/db/DatabaseAdapter';
import { ValidationResponse } from 'src/firebase/db/ValidationManager';

export type Actions =
  | GetBakedBreadTags
  | SuccessGetBakedBreadTags
  | FailGetBakedBreadTags
  | CreateBakedBreadTag
  | SuccessCreateBakedBreadTag
  | FailCreateBakedBreadTag
  | UpdateBakedBreadTags
  | SuccessUpdateBakedBreadTags
  | FailUpdateBakedBreadTags
  | DeleteBakedBreadTag
  | SuccessDeleteBakedBreadTag
  | FailDeleteBakedBreadTag
  | ValidateBakedBreadTag
  | SuccessValidateBakedBreadTag
  | FailValidateBakedBreadTag
  | EditBakedBreadTag
  | InitBakedBreadTag;

/**
 * Get
 */
interface GetBakedBreadTags {
  type: typeof types.GET_BAKED_BREAD_TAGS;
}
export const getBakedBreadTags = () => ({
  type: types.GET_BAKED_BREAD_TAGS,
});

interface SuccessGetBakedBreadTags {
  type: typeof types.SUCCESS_GET_BAKED_BREAD_TAGS;
  payload: APISuccessfulResponse<BakedBreadTagEntity[]>;
}
export const successGetBakedBreadTags = (payload: SuccessGetBakedBreadTags['payload']) => ({
  type: types.SUCCESS_GET_BAKED_BREAD_TAGS,
  payload,
});

interface FailGetBakedBreadTags {
  type: typeof types.FAIL_GET_BAKED_BREAD_TAGS;
  payload: ValidationResponse | APIFailedResponse;
}
export const failGetBakedBreadTags = (payload: FailGetBakedBreadTags['payload']) => ({
  type: types.FAIL_GET_BAKED_BREAD_TAGS,
  payload,
});

/**
 * Create
 */
interface CreateBakedBreadTag {
  type: typeof types.CREATE_BAKED_BREAD_TAG;
  payload: BakedBreadTagEntity;
}
export function createBakedBreadTag(payload: CreateBakedBreadTag['payload']) {
  return {
    type: types.CREATE_BAKED_BREAD_TAG,
    payload,
  };
}

interface SuccessCreateBakedBreadTag {
  type: typeof types.SUCCESS_CREATE_BAKED_BREAD_TAG;
  payload: APISuccessfulResponse<BakedBreadTagEntity>;
}
export function successCreateBakedBreadTag(payload: SuccessCreateBakedBreadTag['payload']) {
  return {
    type: types.SUCCESS_CREATE_BAKED_BREAD_TAG,
    payload,
  };
}

interface FailCreateBakedBreadTag {
  type: typeof types.FAIL_CREATE_BAKED_BREAD_TAG;
  payload: ValidationResponse | APIFailedResponse;
}
export function failCreateBakedBreadTag(payload: FailCreateBakedBreadTag['payload']) {
  return {
    type: types.FAIL_CREATE_BAKED_BREAD_TAG,
    payload,
  };
}

/**
 * Update
 */
interface UpdateBakedBreadTags {
  type: typeof types.UPDATE_BAKED_BREAD_TAGS;
  payload: BakedBreadTagEntity[];
}
export function updateBakedBreadTags(payload: UpdateBakedBreadTags['payload']) {
  return {
    type: types.UPDATE_BAKED_BREAD_TAGS,
    payload,
  };
}

interface SuccessUpdateBakedBreadTags {
  type: typeof types.SUCCESS_UPDATE_BAKED_BREAD_TAGS;
  payload: APISuccessfulResponse<BakedBreadTagEntity[]>;
}
export function successUpdateBakedBreadTags(payload: SuccessUpdateBakedBreadTags['payload']) {
  return {
    type: types.SUCCESS_UPDATE_BAKED_BREAD_TAGS,
    payload,
  };
}

interface FailUpdateBakedBreadTags {
  type: typeof types.FAIL_UPDATE_BAKED_BREAD_TAGS;
  payload: ValidationResponse | APIFailedResponse;
}
export function failUpdateBakedBreadTags(payload: FailUpdateBakedBreadTags['payload']) {
  return {
    type: types.FAIL_UPDATE_BAKED_BREAD_TAGS,
    payload,
  };
}

/**
 * Delete
 */
interface DeleteBakedBreadTag {
  type: typeof types.DELETE_BAKED_BREAD_TAG;
  payload: string;
}
export function deleteBakedBreadTag(payload: DeleteBakedBreadTag['payload']) {
  return {
    type: types.DELETE_BAKED_BREAD_TAG,
    payload,
  };
}

interface SuccessDeleteBakedBreadTag {
  type: typeof types.SUCCESS_DELETE_BAKED_BREAD_TAG;
  payload: APISuccessfulResponse<boolean>;
}
export function successDeleteBakedBreadTag(payload: SuccessDeleteBakedBreadTag['payload']) {
  return {
    type: types.SUCCESS_DELETE_BAKED_BREAD_TAG,
    payload,
  };
}

interface FailDeleteBakedBreadTag {
  type: typeof types.FAIL_DELETE_BAKED_BREAD_TAG;
  payload: ValidationResponse | APIFailedResponse;
}
export function failDeleteBakedBreadTag(payload: FailDeleteBakedBreadTag['payload']) {
  return {
    type: types.FAIL_DELETE_BAKED_BREAD_TAG,
    payload,
  };
}

/**
 * Validate
 */
interface ValidateBakedBreadTag {
  type: typeof types.VALIDATE_BAKED_BREAD_TAG;
  payload: BakedBreadTagEntity;
}
export const validateBakedBreadTag = (payload: ValidateBakedBreadTag['payload']) => ({
  type: types.VALIDATE_BAKED_BREAD_TAG,
  payload,
});

interface SuccessValidateBakedBreadTag {
  type: typeof types.SUCCESS_VALIDATE_BAKED_BREAD_TAG;
  payload: APISuccessfulResponse<BakedBreadTagEntity>;
}
export const successValidateBakedBreadTag = (payload: SuccessValidateBakedBreadTag['payload']) => ({
  type: types.SUCCESS_VALIDATE_BAKED_BREAD_TAG,
  payload,
});

interface FailValidateBakedBreadTag {
  type: typeof types.FAIL_VALIDATE_BAKED_BREAD_TAG;
  payload: ValidationResponse | APIFailedResponse;
}
export const failValidateBakedBreadTag = (payload: FailValidateBakedBreadTag['payload']) => ({
  type: types.FAIL_VALIDATE_BAKED_BREAD_TAG,
  payload,
});

/**
 * ReEdit
 */
interface EditBakedBreadTag {
  type: typeof types.EDIT_BAKED_BREAD_TAG;
  payload: BakedBreadTagEntity;
}
export const editBakedBreadTag = (payload: EditBakedBreadTag['payload']) => ({
  type: types.EDIT_BAKED_BREAD_TAG,
  payload,
});

/**
 * Init state
 */
interface InitBakedBreadTag {
  type: typeof types.INIT_BAKED_BREAD_TAG;
}
export const initBakedBreadTag = () => ({
  type: types.INIT_BAKED_BREAD_TAG,
});
